import { useModalSheet } from 'src/components/contexts/ModalSheetContext'
import CloseModalIcon from 'src/components/Icons/CloseModalIcon'

interface ModalSheetHeaderProps {
  title: string
}

export function ModalSheetHeader({ title }: ModalSheetHeaderProps) {
  const { closeModal } = useModalSheet()

  return (
    <div className="p-4 border-b-sm border-borderPrimary flex flex-row justify-between w-screen md:w-[485px] fixed bg-white z-[1]">
      <p className="font-inter font-normal color-[#101010] text-font-size-5">
        {title}
      </p>
      <button
        className="cursor-pointer"
        data-testid="modal-sheet-close-button"
        onClick={() => closeModal()}
      >
        <CloseModalIcon />
      </button>
    </div>
  )
}
